import * as eases from 'eases-jsnext'
import { setFocus } from '/helpers/misc'

/**
 * Computed navItems property for list pagination
*/
export function navItems(filteredItems, page, navRange) {
	const length = navRange.length
	const pageIndex = page - 1

	// some crazy pagination gatekeeping here, watch out...

	//   1  (2)  3   4   5				✅
	//   1   …   3  (4)  5   …   7		✅
	//   1  (2)  3   …   6				✅
	//   1   2  (3)  4   …   6			✅
	//   1   …   3  (4)  5   6			✅
	//       1   …   4  (5)  6			✅

	let navItems = _.map(navRange, (value, index) => {
		const navItem = { value }
		if (index === pageIndex) {
			navItem.on = true
		}
		if (length > 5) { // more than 5 pages means put `...` somewhere
			navItem.use = false // default
			if (index === pageIndex - 1) { navItem.use = true }
			if (index === pageIndex) { navItem.use = true }
			if (index === pageIndex + 1) { navItem.use = true }
		} else { // five or less just show them all
			navItem.use = true
		}
		return navItem
	})
	if (length > 5) {
		if (page === 1) {
			navItems[2].use = true
			navItems[3].etc = true
			navItems[length - 1].use = true
		} else if (page === 2) {
			navItems[4].etc = true
			navItems[length - 1].use = true
		} else if (page === 3) {
			navItems[0].use = true
			navItems[4].etc = true
			navItems[length - 1].use = true
		} else if (pageIndex === length - 1) {
			navItems[0].use = true
			navItems[length - 4].etc = true
			navItems[length - 3].use = true
		} else if (pageIndex === length - 2) {
			navItems[0].use = true
			navItems[length - 4].etc = true
		} else if (pageIndex === length - 3) {
			navItems[0].use = true
			navItems[length - 5].etc = true
			navItems[length - 1].use = true
		} else {
			navItems[0].use = true
			navItems[1].etc = true
			navItems[length - 2].etc = true
			navItems[length - 1].use = true
		}
	}

	navItems = _.filter(navItems, item => {
		return item.use || item.etc || item.on
	})

	return navItems
}

/**
 * Navigation helper for lists
*/
export function navigate(event, direction) {
	event.preventDefault()
	let page = this.get('page')
	if (direction === 'previous') {
		--page
	} else if (direction === 'next') {
		++page
	} else {
		page = direction
	}
	this.set({ page })

	// scroll up
	this.set({ yPosMirror: this.get('yPos') })
	this.tween('yPosMirror', 0, {
		duration: 1000,
		easing: eases.cubicOut,
	})
	// focus first item
	setFocus(this.refs.list)
}

/**
 * Helper for checking state management on lists
*/
export function checkState(paramName, value, defaultValue) {
	const params = new URLSearchParams(window.location.search)
	const param = params.get(paramName)
	if (_.isNil(value)) {
		const setter = {}
		if (_.isNil(param)) {
			setter[paramName] = defaultValue
			this.set(setter)
			params.set(paramName, defaultValue)
			history.replaceState(null, '', window.location.pathname + '?' + params.toString())
		} else {
			setter[paramName] = param
			this.set(setter)
		}
	} else {
		params.set(paramName, value)
		history.replaceState(null, '', window.location.pathname + '?' + params.toString())
	}
}
